import { useEffect, useState } from 'react';
import useCountDown from 'react-countdown-hook';
import { differenceInSeconds, isAfter, formatDistanceToNow, addMilliseconds } from 'date-fns';
import { ExpiryCountdown } from '../azure-cloud-details-modal.types';
export const useLabExpiryCountdown = (expires?: Date): ExpiryCountdown => {
  const [timeToExpire, {
    start: startExpireCountdown,
    reset: resetExpireCountdown
  }] = useCountDown(0, 1000);
  const [formattedExpiry, setFormattedExpiry] = useState<string | null>(null);
  useEffect(() => {
    const now = new Date();
    if (expires && isAfter(expires, now)) {
      const expiresIn = differenceInSeconds(expires, now);
      startExpireCountdown(expiresIn * 1000);
    } else if (!expires) {
      resetExpireCountdown();
      setFormattedExpiry(null);
    }
  }, [expires, resetExpireCountdown, startExpireCountdown]);
  useEffect(() => {
    if (!timeToExpire || timeToExpire === 0) {
      setFormattedExpiry(null);
      resetExpireCountdown();
    } else {
      setFormattedExpiry(formatDistanceToNow(addMilliseconds(new Date(), timeToExpire), {
        includeSeconds: true
      }));
    }
  }, [resetExpireCountdown, timeToExpire]);
  return {
    formattedExpiry,
    timeToExpire
  };
};